<template>
  <div :class="['productPage']">

    <div class="proSection">
        <div class="background" style="background:#fff">
            <!-- <video src="tmp-video/lynx_bg3.mp4" id="proVid0" playsinline="true" webkit-playsinline="true" preload="auto" muted="muted" class="video-background"></video> -->
        </div>
        <div class="content">
            <div class="psTitle">
                NextGen Simplicity. 
                {{sectionsProgresses[0].prog}}
            </div>    
        </div>
    </div>

    <div class="proSection" style="border:solid 5px red;">
         <seq-section></seq-section>
    </div>

    <div class="proSection">
        <div class="background" style="background:#fff">
            <!-- <video src="tmp-video/lynx_bg2.mp4" id="proVid1" playsinline="true" webkit-playsinline="true" preload="auto" muted="muted" class="video-background"></video> -->
        </div>
        <div class="content">
            <div class="psTitle">
                Adaptive Placement for Surgical Simplicity.
                {{sectionsProgresses[1].prog}}
            </div>    
        </div>
    </div>

  </div>
</template>

<style>
    .productPage
    {
        width: 100%;
        min-height: 50vh;
    }
    .proSection
    {
        width: 100vw;
        height: calc(100vh - 90px);        
        position: relative;
    }
    .proSection .background
    {
        position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;
        background-color: #202020;
        z-index: 100;
    }
    .proSection .background video
    {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    .proSection .content
    {
        position: absolute;top: 0px;left: 0px;
        width: 100%;
        height: 100%;
        padding: 0px 5vw;
        display: flex;
        align-content: center;
        align-items: center;
        z-index: 200;
    }

    .psTitle{
        width: 60%;
        font-size: 60px;color: #202020;
        letter-spacing: -2px !important;
    }
</style>



<script>

  //import SeqSection from "./SeqSection.vue"; 
  import { mapActions, mapState } from "vuex";  
  export default 
  {
    components:
    {
        //SeqSection
    },
    data(){
      return{
        visibleSection:0,
        activeIndex: 0,
        children:[],
        sectionsProgresses:[
            {prog:0,time:0,videoID:'proVid0'},
            {prog:0,time:0,videoID:'proVid1'}
        ],
        progress:100,
      }
    },  
    components:
    {
    }, 
    computed: {
        //...mapState(["siteData","siteDataReady","siteReady","minisite_VisibleSection","pageLayoutData"]),
    },
    mounted()
    {
        var vm=this;
        //vm.progress=20000;
        //vm.initScrollListener();
    },

    methods:
    {
    initScrollListener() 
    {
      var vm=this;
      //let isM = isMobileScreen();
      //vm.sectionsProgresses[0]=1;
      
      setTimeout(() => {    
        //if(isMobileScreen()==false)
        //{
          //var scrollContainer = document.getElementById("mainScroller");
          //scrollContainer.addEventListener("scroll", vm.scrollHandler, false);    
        //}else
        //{
          document.addEventListener("scroll", vm.scrollHandler, false);
        //}
      }, 1000);
    },    
    scrollHandler() {      
      var vm=this;      
      this.checkSectionsView();
    },
    checkSectionsView()
    {      
      var vm=this;
        //alert("check1");
      var reveals = document.querySelectorAll(".proSection");
      for (var i = 0; i < reveals.length; i++) 
      {
        var curElement = reveals[i];
        var windowHeight = window.innerHeight;
        var elRect = reveals[i].getBoundingClientRect();
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = windowHeight*1;//350;

        // distance from top of viewport to top of container
        var scrollTop = window.innerHeight - elRect.top; 
        // total scrollable distance within the container
        var scrollHeight = elRect.height + window.innerHeight;
        // clamp between 0 and 1
        const scrollFraction = Math.min(Math.max(scrollTop / scrollHeight, 0), 1);
        //set time
        var videoEl = document.getElementById(vm.sectionsProgresses[i].videoID);
        var duration = 3;
        var videoTime = scrollFraction * duration;
        vm.sectionsProgresses[i].time=videoTime;
        videoEl.currentTime = videoTime;



        //if(curElement.classList.contains('sequence'))
        //{
/*             let secHeight = elRect.height;
            let scrollWay = secHeight - windowHeight;
            let precentageOfSequence = Math.round(Math.abs(elementTop-90)/secHeight*100);
            let sectionProg = precentageOfSequence/100;
            vm.sectionsProgresses[i].prog=sectionProg;
            var videoTime = 6*sectionProg;//2 sec video test
            vm.sectionsProgresses[i].time=videoTime;
            var videoEl = document.getElementById(vm.sectionsProgresses[i].videoID);
            videoEl.currentTime = videoTime;
 */

            //vid.currentTime = 5;


            if (elementTop < 0 && elementTop > 0 - scrollWay)// && elementTop>0)
            {
              //CALCULATE THE PRECENTAGE OF THE ELEMENT SEQUENCE
              //let precentageOfSequence = Math.round(Math.abs(elementTop/scrollWay) * 100);
              //let sectionProg = precentageOfSequence/100;
              //let sectionIndex = i>0 ? i-1 : 0; //get the data index and not the dom index
              //this.setSectionProgress({index:sectionIndex,prog:sectionProg});
              //vm.sectionsProgresses[sectionIndex]= sectionProg;
            }
        //}
        //*/

      }
    },
    onSectionVisible(domSectionIndex)
    {
        
        var vm=this;
        //let sectionIndex = domSectionIndex;
        //let sectionDataIndex = sectionIndex;
        //var sectionElement = document.querySelectorAll(".siteSection")[domSectionIndex];
        //this.revealSectionChildrenElements(sectionElement,domSectionIndex);
    },    
    revealSectionChildrenElements(parentElement,domSectionIndex) 
    {
      var vm=this;
      //parentElement.classList.add("active");
      //var reveals = parentElement.querySelectorAll(".reveal");
      //for (var i = 0; i < reveals.length; i++){
          //if(reveals[i].classList.contains("active")==false){
            //vm.onRevealingSection(reveals[i].id);
            //reveals[i].classList.add("active");
          //}
      //}
    },
    onRevealingSection(sectionID)
    {
        //add here specific site logic ...
    },       
    setActiveIndex(index)
    {
        this.activeIndex = index;
    }
  }
  }
</script>


